import { ButtonList } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { User } from 'lib-shared-types-api';

import { useExcludeContactFromCsatSurvey } from './useExcludeContactFromCsatSurvey';
type ToggleUserCsatExclusionButtonListItemProps = {
  /** The user that will be csat-excluded/included */
  user: User;
  /** Callback to be called when the button is clicked */
  onToggle?: () => void;
};

/**
 * Button list item to toggle the exclusion of a user from CSAT surveys.
 *
 * @returns A `ButtonList.Item` to toggle the exclusion of a user from CSAT
 *   surveys.
 */
export function ToggleUserCsatExclusionButtonListItem({
  user,
  onToggle,
}: ToggleUserCsatExclusionButtonListItemProps): JSX.Element | null {
  const hasSatisfactionAccess = useHasAccess('settings.satisfaction');
  const { toggleExclusion, isAlreadyExcluded, isLoadingUserExclusion } =
    useExcludeContactFromCsatSurvey(user);

  // Don't render the button if the user doesn't have permission
  if (!hasSatisfactionAccess) {
    return null;
  }

  const buttonLabel = isAlreadyExcluded
    ? 'Remove from surveys exclusion list'
    : 'Exclude from satisfaction surveys';

  return (
    <ButtonList.Item
      icon="star"
      onClick={() => {
        toggleExclusion();
        onToggle?.();
      }}
      isLoading={isLoadingUserExclusion}
      isDisabled={isLoadingUserExclusion}
    >
      {buttonLabel}
    </ButtonList.Item>
  );
}
